<div class="filtro-busca-imobiliario-wrapper">
  <div class="filtros-col">
    <app-filtro-busca-salva
      [buscaSelecionada]="buscaSalvaId"
      [modoEdicao]="modoEdicao"
      (buscaSalvaChange)="onBuscasSalvasChange($event)"
      (buscaSalvaFiltros)="onBuscaSalvaFiltros($event)"
      [disabled]="!temAcessoModulo && !modoEdicao"
    ></app-filtro-busca-salva>
    <app-filtro-regiao
      [buscaSalvaRegiao]="
        filtrosSelecionados.regiao
          ? {
              addressStateID: filtrosSelecionados.regiao,
              addressCityID: filtrosSelecionados.cidades,
              addressLocationID: filtrosSelecionados.localidades,
              neighborhoodAddressID: filtrosSelecionados.bairros,
            }
          : null
      "
      (filtrosChange)="onRegiaoChange($event)"
      [disabled]="!temAcessoModulo && !modoEdicao"
    ></app-filtro-regiao>

    <app-filtro-tipo-obra
      (tiposObraChange)="onTiposObraChange($event)"
      [tiposSelecionados]="filtrosSelecionados.workTypeID"
      [disabled]="!temAcessoModulo && !modoEdicao"
    ></app-filtro-tipo-obra>
    <app-filtro-padrao-obra
      (padroesObraChange)="onPadroesObraChange($event)"
      [padroesSelecionados]="filtrosSelecionados.patternWorkID"
    ></app-filtro-padrao-obra>
    <app-filtro-fase-obra
      (fasesObraChange)="onFasesObraChange($event)"
      [fasesSelecionadas]="filtrosSelecionados.workPhaseID"
    ></app-filtro-fase-obra>
    <app-filtro-cadastrada-em
      (cadastradaEmChange)="onCadastradaEmChange($event)"
      [cadastradaEmSelecionado]="filtrosSelecionados.registeredIn"
    ></app-filtro-cadastrada-em>

    <app-filtro-busca-somente
      [checkedOptionsIds]="checkedBuscarSomenteIds"
      (buscarSomenteChange)="onBuscarSomenteChange($event)"
      [disabled]="!temAcessoModulo && !modoEdicao"
    ></app-filtro-busca-somente>

    <app-filtro-termino-obra
      (terminoObraChange)="onTerminoObraChange($event)"
      [terminoObraSelecionado]="{
        dataInicio: filtrosSelecionados.workEndDateBegin,
        dataFim: filtrosSelecionados.workEndDateEnd,
      }"
    >
    </app-filtro-termino-obra>

    <div
      class="tipo-de-obra-content titles"
      appDropdownToggle
      #dropdown="dropdownToggle"
      (click)="dropdown.toggle()"
      tabindex="0"
    >
      <div class="icon-text">
        <span class="icon-circle">
          <img
            class="img-icon"
            src="{{
              BASE_IMG_URL
            }}assets/filtro-lateral-busca/bookmark.svg"
            alt=""
            width="22"
            height="22"
          />
        </span>

        <h2>SALVAR BUSCA</h2>
      </div>
      <a
        class="btn tipo-de-obra-link"
        data-bs-toggle="collapse"
        role="button"
        aria-expanded="true"
        href="#BTN-SALVAR"
        (click)="$event.stopPropagation(); dropdown.toggle()"
        (keydown.enter)="dropdown.toggle()"
        (keydown.space)="dropdown.toggle()"
      >
        <img
          class="img-icon"
          [ngClass]="{ 'girar-icon': dropdown.isOpen }"
          src="{{
            BASE_IMG_URL
          }}assets/filtro-lateral-busca/icone-seta-fechar.svg"
          alt=""
          width="18"
          height="18"
        />
      </a>
    </div>

    <div class="collapse show check-total" id="BTN-SALVAR" *ngIf="!modoEdicao">
      <div class="form-check salvar-obra">
        <input
          type="text"
          placeholder="Nome da busca"
          class="input-placeholder-italic"
          #nomeBuscaInput
          [disabled]="!temAcessoModulo"
        />
        <button
          (click)="salvarBusca()"
          type="button"
          [disabled]="!temAcessoModulo"
        >
          <span>SALVAR</span>
        </button>
      </div>
    </div>

    <div
      class="collapse show check-total"
      id="BTN-SALVAR-EDICAO"
      *ngIf="modoEdicao"
    >
      <div class="form-check salvar-obra-edit">
        <input
          type="text"
          placeholder="Nome da busca"
          class="input-placeholder-italic"
          #nomeBuscaEditadaInput
          [value]="savedSearchName"
          (input)="onNomeEdicaoChange($any($event.target).value)"
          [disabled]="!temAcessoModulo && !modoEdicao"
        />
        <button
          (click)="salvarEdicaoBusca()"
          type="button"
          [disabled]="!temAcessoModulo && !modoEdicao"
        >
          <span>SALVAR EDIÇÃO</span>
        </button>
      </div>
    </div>

    <div class="btns-filtro">
      <div class="limpar-filtros">
        <button
          type="button"
          (click)="limparFiltros()"
          [disabled]="!temAcessoModulo && !modoEdicao"
          [class.disabled]="!temAcessoModulo && !modoEdicao"
        >
          LIMPAR
        </button>
      </div>

      <div class="ver-todos-filtros row">
        <button
          (click)="openModal()"
          type="button"
          [disabled]="!temAcessoModulo && !modoEdicao"
          [class.disabled]="!temAcessoModulo && !modoEdicao"
        >
          <span>MAIS FILTROS</span>
        </button>
      </div>
    </div>
  </div>
</div>

<app-modal-mensagem
  *ngIf="modalMensagem"
  [tipo]="modalMensagem.tipo"
  [titulo]="modalMensagem.titulo"
  [mensagem]="modalMensagem.mensagem"
  (confirmar)="onFecharModalMensagem()"
></app-modal-mensagem>
